import { capitalize } from "../string";
import getDateFnsLocale from "./getDateFnsLocale";

const localizeMonth = (month: number, language: string) => (
  capitalize(getDateFnsLocale(language).localize.month(month))
);

export default localizeMonth;
